import React from 'react';
import './stratergy-overview.scss';
import { default as t } from '../../../utils/i18n';
function StretargyOverview(props) {
  const genderMapping = {
    0: 'All',
    1: 'Male',
    2: 'Female',
  };
  const overviewData = props?.data?.reportData?.strategy_overview;
  return (
    <>
      <div className="overView">
        <div>
          <p>{t('overview.ad.format.type')} </p>
          <span>{overviewData?.ad_format_type?.join(', ')}</span>
        </div>
        <div>
          <p>{t('overview.audience.type')}</p>
          <span>{overviewData?.audience_type?.join(', ')}</span>
        </div>
        <div>
          <p>{t('overview.placement')}</p>
          <span>
            {overviewData?.placement?.facebook_positions &&
              overviewData?.placement?.facebook_positions?.map(x => 'facebook ' + x).join(', ')}
            {overviewData?.placement?.instagram_positions
              ? ', ' +
                overviewData?.placement?.instagram_positions?.map(x => 'instagram ' + x).join(', ')
              : ''}
          </span>
        </div>
        <div>
          <p>{t('overview.age')}</p>
          <span>{overviewData?.age}</span>
        </div>
        <div>
          <p>{t('overview.gender')}</p>
          <span>{overviewData?.gender?.length > 0 && overviewData?.gender?.map(x => genderMapping[x]).join(', ')}</span>
        </div>
      </div>
    </>
  );
}

export default StretargyOverview;
